import React, { useEffect, useState } from 'react';
import {
  // Card,
  Checkbox,
  Col,
  Collapse,
  Input,
  InputNumber,
  Row,
  Typography,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateAddonsReturnEditOrder,
  updateCabinsReturnEditOrder,
} from '../../../redux/actions/EditOrderAction';
import _ from 'lodash';
// import dayjs from 'dayjs';
import useTime from '../../../hooks/useTime';
import IntlMessage from '../../../components/IntlMessage';

const { Text, Title } = Typography;
const { TextArea } = Input;

function roundToThousands(number) {
  return Math.round(number / 1000) * 1000;
}

const Return = (props) => {
  const searchValues = useSelector((state) => state.editOrder.searchValues);
  const returnOrder = useSelector((state) => state.editOrder.return);
  // states
  const { searchData, customer } = props;
  const [returnSearchItems, setReturnSearchItems] = useState([]);
  const [cabinsReturnChecked, setCabinsReturnChecked] = useState([]);
  const [addonsReturnChecked, setAddonsReturnChecked] = useState([]);
  const [activeReturn, setActiveReturn] = useState([
    returnOrder?.cabins[0]?.hop_id,
  ]);
  const [isChangeActive, setIsChangeActive] = useState(false);
  const [currentRouteId, setCurrentRouteId] = useState(
    returnOrder?.cabins[0]?.hop_id
  );
  const { convertToAnyTimezone } = useTime();

  // side effects
  useEffect(() => {
    const route = _.find(searchData, {
      id: returnOrder?.cabins[0]?.hop_id,
    });
    // console.log('route: ', route);
    if (route) {
      const cabins = route?.cabins;
      const addons = route?.hop_addons;
      if (Array.isArray(cabins)) {
        let cabinChecked = [];
        cabins.forEach((cabin) => {
          let item = _.find(returnOrder?.cabins, {
            cabin_id: cabin?.id,
          });
          if (item) {
            cabinChecked.push(`${item?.hop_id}-${item?.cabin_id}`);
          }
        });
        setCabinsReturnChecked(cabinChecked);
      }
      if (Array.isArray(addons)) {
        let addonChecked = [];
        addons.forEach((addon) => {
          let item = _.find(returnOrder?.addons, {
            addon_id: addon?.addon?.id,
          });
          if (item) {
            addonChecked.push(`${item?.hop_id}-${item?.addon_id}`);
          }
        });
        setAddonsReturnChecked(addonChecked);
      }
    }
  }, []);

  useEffect(() => {
    if (searchData.length > 0) {
      setReturnSearchItems(
        searchData.map((item, index) => {
          return {
            key: item?.id,
            label: `${item?.route?.title} - ${item?.route?.operator?.title}`,
            style: {
              marginBottom: 12,
              background: '#00000005',
              borderRadius: '8px',
              border: 'none',
            },
            children: (
              <React.Fragment>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <Text style={{ fontWeight: 'bold' }}>
                      <IntlMessage id="global.cabins" />
                    </Text>
                  </Col>
                  <Col span={6}>
                    <Text style={{ fontWeight: 'bold' }}>
                      <IntlMessage id="global.price" />
                    </Text>
                  </Col>
                  <Col span={4}>
                    <Text style={{ fontWeight: 'bold' }}>
                      <IntlMessage id="global.qty" />
                    </Text>
                  </Col>
                  <Col span={6}>
                    <Text style={{ fontWeight: 'bold' }}>
                      <IntlMessage id="global.notes" />
                    </Text>
                  </Col>
                </Row>
                <br />
                <Checkbox.Group
                  style={{ width: '100%', flexDirection: 'column' }}
                  onChange={(value) => handleCheckedCabinReturn(value, item)}
                  value={cabinsReturnChecked}
                >
                  <Row gutter={[16, 16]}>
                    {item?.cabins?.map((cabin, index) => (
                      <Cabin
                        key={index}
                        hop={item}
                        cabin={cabin}
                        customer={customer}
                        checked={cabinsReturnChecked.find(
                          (checked) => checked === `${item?.id}-${cabin?.id}`
                        )}
                      />
                    ))}
                  </Row>
                </Checkbox.Group>
                <br />
                <Text style={{ fontWeight: 'bold' }}>
                  <IntlMessage id="global.addons" />
                </Text>
                <Checkbox.Group
                  style={{
                    width: '100%',
                    flexDirection: 'column',
                    marginTop: '6px',
                  }}
                  onChange={(value) => handleCheckedAddonReturn(value, item)}
                  value={addonsReturnChecked}
                >
                  <Row gutter={[16, 16]}>
                    {item?.hop_addons?.map((addon, index) => (
                      <Addon
                        key={index}
                        hop={item}
                        addon={addon}
                        checked={addonsReturnChecked.find(
                          (checked) =>
                            checked === `${item?.id}-${addon?.addon?.id}`
                        )}
                      />
                    ))}
                  </Row>
                </Checkbox.Group>
              </React.Fragment>
            ),
          };
        })
      );
    }
  }, [searchData, cabinsReturnChecked, addonsReturnChecked, customer]);

  const onChangeReturnCollapse = (key) => {
    setIsChangeActive(true);
    setActiveReturn(key.length > 0 ? [key[key.length - 1]] : []);
  };

  const handleCheckedCabinReturn = (value, route) => {
    if (isChangeActive && currentRouteId !== route.id) {
      setAddonsReturnChecked([]);
      setIsChangeActive(false);
    }
    setCurrentRouteId(route.id);
    setCabinsReturnChecked(value);
  };

  const handleCheckedAddonReturn = (value, route) => {
    if (isChangeActive && currentRouteId !== route.id) {
      setCabinsReturnChecked([]);
      setIsChangeActive(false);
    }
    setCurrentRouteId(route.id);
    setAddonsReturnChecked(value);
  };

  return (
    <React.Fragment>
      {/* <br /> */}
      {/* <Card
        title={`Return ${searchData[0].start_stop.title} - ${searchData[0].end_stop.title}`}
        style={{ border: 'none' }}
      >
      </Card> */}
      <Title level={5}>
        {`Return ${searchData[0].start_stop.title} - ${
          searchData[0].end_stop.title
        } ${convertToAnyTimezone(searchValues?.return_date).format(
          'DD/MM/YYYY'
        )}`}
      </Title>
      <Collapse
        items={returnSearchItems}
        onChange={onChangeReturnCollapse}
        activeKey={activeReturn}
        bordered={false}
        style={{
          background: '#ffffff',
        }}
      />
    </React.Fragment>
  );
};

const Cabin = (props) => {
  const dispatch = useDispatch();
  const returnCabins = useSelector((state) => state.editOrder.return.cabins);
  // states
  const { hop, customer, cabin, checked } = props;
  const [cabinPrice, setCabinPrice] = useState(
    customer?.cgroup?.discount
      ? roundToThousands(
          Number(cabin?.cabin_rates?.price) -
            (Number(cabin?.cabin_rates?.price) *
              Number(customer?.cgroup?.discount)) /
              100
        )
      : roundToThousands(Number(cabin?.cabin_rates?.price))
  );
  const [cabinQty, setCabinQty] = useState(1);

  // side effects
  useEffect(() => {
    const item = _.find(returnCabins, {
      hop_id: hop?.id,
      cabin_id: cabin?.id,
    });
    if (item) {
      setCabinPrice(roundToThousands(item?.price));
      setCabinQty(item?.quantity);
    }
  }, []);

  useEffect(() => {
    if (cabinQty > 0) {
      // console.log('Cabin re-rendering');
      dispatch(
        updateCabinsReturnEditOrder({
          value: {
            hop_id: hop?.id,
            cabin_id: cabin?.id,
            title: cabin?.title,
            price: roundToThousands(cabinPrice),
            quantity: cabinQty,
          },
          checked,
        })
      );
    }
  }, [checked, cabinPrice, cabinQty]);

  const handleChangePrice = (value) => {
    setCabinPrice(value);
  };

  const handleChangeQty = (value) => {
    setCabinQty(value);
  };

  return (
    <React.Fragment>
      <Col span={8}>
        <Checkbox
          value={`${hop?.id}-${cabin?.id}`}
          // disabled={cabin?.cabin_rates?.seat_available < 1}
        >
          {cabin?.title}
        </Checkbox>
      </Col>
      <Col span={6}>
        <InputNumber
          min={1}
          value={cabinPrice}
          disabled={!checked}
          onChange={handleChangePrice}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ minWidth: '100px' }}
        />
        <Text> per {cabin?.price_type}</Text>
        <Text style={{ display: 'block', marginTop: '12px' }}>
          {cabin?.cabin_rates?.seat_available <= 0
            ? 0
            : cabin?.cabin_rates?.seat_available}{' '}
          available
        </Text>
      </Col>
      <Col span={4}>
        <InputNumber
          min={1}
          // max={Number(cabin?.cabin_rates?.seat_available)}
          value={cabinQty}
          disabled={!checked}
          onChange={handleChangeQty}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ minWidth: 'min-content' }}
        />
      </Col>
    </React.Fragment>
  );
};

const Addon = (props) => {
  const dispatch = useDispatch();
  const returnAddons = useSelector((state) => state.editOrder.return.addons);
  // states
  const { hop, addon, checked } = props;
  const [addonPrice, setAddonPrice] = useState(
    roundToThousands(Number(addon?.addon?.price))
  );
  const [addonQty, setAddonQty] = useState(1);
  const [notes, setNotes] = useState('');

  // side effects
  useEffect(() => {
    const item = _.find(returnAddons, {
      hop_id: hop?.id,
      addon_id: addon?.addon?.id,
    });
    if (item) {
      setAddonPrice(roundToThousands(item?.price));
      setAddonQty(item?.quantity);
      setNotes(item?.notes);
    }
  }, []);

  useEffect(() => {
    const setNotesFuc = _.debounce(async () => {
      if (addonQty > 0) {
        // console.log('Addon re-rendering');
        dispatch(
          updateAddonsReturnEditOrder({
            value: {
              hop_id: hop?.id,
              addon_id: addon?.addon?.id,
              title: addon?.addon?.title,
              price: roundToThousands(addonPrice),
              quantity: addonQty,
              notes,
            },
            checked,
          })
        );
      }
    }, 300);
    setNotesFuc();

    return () => {
      clearTimeout(setNotesFuc);
    };
  }, [checked, addonPrice, addonQty, notes]);

  const handleChangePrice = (value) => {
    setAddonPrice(value);
  };

  const handleChangeQty = (value) => {
    setAddonQty(value);
  };

  const handleChangeNotes = (e) => {
    setNotes(e.target.value);
  };

  return (
    <React.Fragment>
      <Col span={8}>
        <Checkbox value={`${hop?.id}-${addon?.addon?.id}`}>
          {addon?.addon?.title}
        </Checkbox>
      </Col>
      <Col span={6}>
        <InputNumber
          min={1}
          value={addonPrice}
          disabled={!checked}
          onChange={handleChangePrice}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ minWidth: '100px' }}
        />
        <Text> per {addon?.addon?.type}</Text>
      </Col>
      <Col span={4}>
        <InputNumber
          min={1}
          value={addonQty}
          disabled={!checked}
          onChange={handleChangeQty}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          style={{ minWidth: 'min-content' }}
        />
      </Col>
      <Col span={6}>
        <TextArea
          placeholder="Add notes"
          value={notes || ''}
          onChange={handleChangeNotes}
          disabled={!checked}
          rows={2}
        />
      </Col>
    </React.Fragment>
  );
};

export default Return;
